export const CUSTODIAN_AGREEMENTS_TEXTS = {
	sectionTitle: 'Custodian Agreements',
	requiredNotSigned:
		'Your account cannot be opened until you have signed all required Custodian Agreements. Please review and sign all required agreements in the Custodian Agreements section.',
	documentUnavailable:
		'The document is currently unavailable. Please try again later or contact support if the issue persists.',
	agreeAction: 'I Agree',
	agreedActionDone: 'Signed',
};
